import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

import backgroundImg from './img/background.jpg'

import overlay from './img/overlay.png'

const Intro = ({
  coupleData: { coupleSimplifiedName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro372">
      <div className="animated-intro-large screen">
        <img
          className="background-p4EdWL"
          src={background || backgroundImg}
          alt="Background"
        />
        <div className="button-p4EdWL">
          <p
            className="site-de-casamento-e-CpwLjN"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <div className="button-CpwLjN smart-layers-pointers">
            <div className="pular-introduo-fo8x79" onClick={onSkipIntro}>
              {buttonMessage}
            </div>
          </div>
        </div>
        <img
          className="monograma-p4EdWL bp1-animate-enter"
          src={overlay}
          alt="Monograma"
        />
        <div className="couple-name-p4EdWL couple-name bp1-animate-enter2">
          <h1 className="couple-name-VF7rnS couple-name bp1-animate-enter1">
            <span className="borniarte-regular-normal-shark-56px">
              {coupleSimplifiedName.bride}
              <br />
            </span>
            <span className="span-rzkjyO">
              &amp;
              <br />
            </span>
            <span className="borniarte-regular-normal-shark-56px">
              {coupleSimplifiedName.groom && coupleSimplifiedName.groom}
            </span>
          </h1>
        </div>
      </div>
      <div className="full-project screen">
        <img
          className="background-KqxCzi"
          src={background || backgroundImg}
          alt="Background"
        />
        <div className="button-KqxCzi">
          <p
            className="site-de-casamento-e-FRZ0F7"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <div className="button-FRZ0F7 smart-layers-pointers">
            <div className="pular-introduo-kvlGz8" onClick={onSkipIntro}>
              {buttonMessage}
            </div>
          </div>
        </div>
        <img
          className="monograma-KqxCzi bp2-animate-enter"
          src={overlay}
          alt="Monograma"
        />
        <div className="couple-name-KqxCzi couple-name bp2-animate-enter2">
          <h1 className="couple-name-AjOh3J couple-name bp2-animate-enter1">
            <span className="borniarte-regular-normal-shark-56px">
              {coupleSimplifiedName.bride}
              <br />
            </span>
            <span className="span-MfMQtq">
              &amp;
              <br />
            </span>
            <span className="borniarte-regular-normal-shark-56px">
              {coupleSimplifiedName.groom && coupleSimplifiedName.groom}
            </span>
          </h1>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
